import { getAlreadyPaidAmount } from "../../../../addCoverage/utils/reservationHelpers";

export const computeCarSwapAmountDue = (invoiceTotal, alreadyPaid) =>
    Math.max(0, Math.round((Number(invoiceTotal || 0) - Number(alreadyPaid || 0)) * 100) / 100);

export const buildCarSwapReservationInvoice = ({ quoteInvoice, resDetails, additionalPaid = 0 }) => {
    const alreadyPaid = getAlreadyPaidAmount(resDetails);
    const total = Number(quoteInvoice?.total || 0);
    const deposit = Math.max(0, Math.round((alreadyPaid + Number(additionalPaid || 0)) * 100) / 100);
    const due = computeCarSwapAmountDue(total, deposit);

    return {
        ...resDetails?.invoice,
        ...quoteInvoice,
        charges: quoteInvoice?.charges || [],
        taxes: quoteInvoice?.taxes,
        estimatedTotal: quoteInvoice?.estimatedTotal,
        total,
        deposit,
        due,
    };
};
